/** Bounded prefix match — `path` OR `path + '/'` — so `/catalog-enrichment/runs-x` can't light up Runs. */
export function isUnder(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(prefix + '/');
}
